import { DASHBOARD_QUERY } from "@/features/dashboard/graphql/dashboard-query";
import { DashboardLayout } from "@/features/dashboard/layout";

export const Route = createFileRoute({
  component: DashboardLayout,
  loader: async ({ context, params }) => {
    if (context.urqlClient) {
      await context.urqlClient
        .query(DASHBOARD_QUERY, { organizationId: params.orgId })
        .toPromise();
    }
  },
});
